let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f3oeA")).then(() => parcelRequire('6ZQ6l'));